import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import ChangeLanguage from '@/components/molecules/ChangeLanguage/ChangeLanguage';

import styles from './public.module.scss';

interface PublicVideoLayoutProps {
    children: ReactNode;
}

/**
 * The video backdrop, tagline and logo column of the login and password reset pages, so
 * signing in, asking for a reset and the reset the email links to look like one flow.
 */
export function PublicVideoLayout({ children }: PublicVideoLayoutProps) {
    const { t } = useTranslation();

    return (
        <div className={styles.loginContainer}>
            <video autoPlay loop muted className={styles.backgroundVideo}>
                <source src="./loginVideoBg.mp4" type="video/mp4" />
            </video>

            <div className={styles.loginRow}>
                <div className={styles.leftColumn}>
                    <div className={styles.overlayContent}>
                        <h1>{t('publicPages.common.discoverPrecision')}</h1>
                        <p>{t('publicPages.common.getFullControlOfFish')}</p>
                    </div>
                </div>
                <div className={styles.rightColumn}>
                    <div className={styles.topSection}>
                        <img src="/logo.png" alt="" className={styles.logo} />
                        <div className={styles.languageBox}>
                            <ChangeLanguage surface="inverse" />
                        </div>
                    </div>
                    <div className={styles.loginBox}>{children}</div>
                </div>
            </div>
        </div>
    );
}
